import Vue from "vue";
import Tabulator from "tabulator-tables/dist/css/tabulator_semanticui.min.css"
import "./custom-tabulator.css";

Vue.use(Tabulator);

export default Tabulator;
